// angular
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppService } from '../../../../app.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'me-landing-page-expert',
    templateUrl: './landing-page-expert.component.html',
    styleUrls: ['./landing-page-expert.component.scss'],
})

export class MeLandingPageExpertComponent implements OnInit {
    @Input() data : any = {};
    items = [];
    activeTherapist : any = {};
    mousePosition = {
        x: 0,
        y: 0
    };

    @ViewChild('modalViewTherapist', {static: false}) modalViewTherapist: ModalDirective;

    customOptions: OwlOptions = {
        items: 3,
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        dots: true,
        navSpeed: 700,
        responsive: {
            0: {
              items: 1
            },
            400: {
              items: 2
            },
            740: {
              items: 3
            },
        },
    }

    constructor(
        public appService: AppService
    ) {
       
    }

    ngOnInit() {
        this.data.therapists.forEach((uid, index) => {
            this.appService.getStoryBlokSlugByUuid(uid).subscribe(res => {
                if (res['story'] && res['story']['content']) {
                    let content = res['story']['content'];
                    this.items.splice(index, 0 , {
                        name : res['story']['name'],
                        image : content['image']['filename'],
                        languages : content['languages'],
                        title : content['title'],
                        content: content['text'],
                        joinDate: content['joinDate'],
                        uid: uid
                    });
                }
            });
        });
    }

    onMouseDown($event) {
        this.mousePosition.x = $event.screenX;
        this.mousePosition.y = $event.screenY;
    }
    
    openTherapistModal($event, item) {
        if (
            this.mousePosition.x === $event.screenX &&
            this.mousePosition.y === $event.screenY
          ) {
            this.activeTherapist = item;
            this.modalViewTherapist.show();
        }
    }
}
